import React from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { checkAnimation } from "../../resources/js/gifs";
import H4 from "../../shared/typography/H4";
import P from "../../shared/typography/P";
import Button from "../../shared/ui/Button";
import TextField from "../../shared/ui/Form/TextField";

const Activation = ({ data, setShowModal }) => {
    return data ? (
        <>
            <div className=" bg-blue-550 mx-2 md:mx-auto md:bg-white md:border md:shadow-md rounded-2.5 md:rounded-3xl md:w-[80%] p-2 md:p-2">
                <div className="flex flex-wrap  justify-between items-center gap-1  my-2 md:my-3">
                    <P className="w-full 2xs:w-1/2 text-white md:text-primary">
                        Current Stage
                    </P>
                    <TextField
                        label={""}
                        disabled={true}
                        value={"Application and Approval"}
                        name={""}
                        wrapper={"h-[40px] "}
                        size={
                            "w-full   !bg-blue-550 md:!bg-white border-white md:border-blue-400"
                        }
                        inputWrapper=" text-center text-xs !bg-blue-550 !text-white md:!bg-white md:!text-primary border-white md:border-blue-400 rounded-l-lg "
                        type={"text"}
                    />
                </div>
                <div className="flex flex-wrap  justify-between items-center gap-1  my-2 md:my-3">
                    <P className="w-full 2xs:w-1/2 text-white md:text-primary">
                        Status
                    </P>
                    <div className="flex w-full items-center gap-1 text-center justify-center  border-2  p-0.5  !bg-blue-550 !text-white md:!bg-white md:!text-primary border-white md:border-gray-170 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-lg ">
                        <P className="text-white md:text-primary">
                            In Progress
                        </P>
                        <P className="text-orange text-lg lg:text-xl xl:text-xl">
                            <RiErrorWarningFill />
                        </P>
                    </div>
                </div>
                <div className="flex flex-wrap  justify-between items-center gap-1  my-2 md:my-3">
                    <P className="w-full 2xs:w-1/2 text-white md:text-primary">
                        Tentative Deadline
                    </P>
                    <TextField
                        label={""}
                        disabled={true}
                        value={"05/02/2025"}
                        name={""}
                        wrapper={"h-[40px] "}
                        size={
                            "w-full   !bg-blue-550 md:!bg-white border-white md:border-blue-400"
                        }
                        inputWrapper=" text-center text-xs  !bg-blue-550 !text-white md:!bg-white md:!text-primary border-white md:border-blue-400 rounded-l-lg "
                        type={"text"}
                    />
                </div>
                <div className="flex justify-end items-center">
                    <Button
                        className="w-full  bg-blue-100 md:bg-primary"
                        onClick={() => setShowModal((prev) => !prev)}
                    >
                        Call Sales Executive
                    </Button>
                </div>
            </div>
            <div className="bg-white  lg:border md:block    md:shadow-md min-h-[70rem] md:min-h-full md:overflow-y-scroll  md:max-h-[20rem] rounded-t-2.5 md:rounded-3xl w-full p-3 md:p-1 mt-4 md:mt-0 md:mb-5">
                {data?.map((task, index) => (
                    <div
                        key={task?.id}
                        className="bg-white  md:p-1 mb-4 md:mb-2 "
                    >
                        <div className=" flex justify-between items-center">
                            <div className="flex items-center gap-1">
                                <div className="w-1 h-1 bg-primary rounded-full md:bg-secondary md:w-0.8 md:h-0.8 " />
                                <H4 className="md:text-secondary md:text-lg md:font-normal">
                                    {task?.name}
                                </H4>
                            </div>
                            {task?.completionTime === 0 ? (
                                <img
                                    src={checkAnimation}
                                    alt="Completed"
                                    className="w-3 h-3"
                                />
                            ) : (
                                <div className="w-2 h-2 bg-blue-300 rounded-full mr-1 "></div>
                            )}
                        </div>
                        <div className="flex justify-between items-center my-1.5">
                            <P className="text-gray-600 text-sm sm:text-sm xl:text-sm">
                                {task?.date}
                            </P>
                            {task?.completionTime && (
                                <P className=" text-sm sm:text-sm xl:text-sm text-gray-500">
                                    ETA: +{task?.completionTime} days
                                </P>
                            )}
                        </div>
                        <P className=" text-gray-500 text-sm sm:text-sm xl:text-sm">
                            {task?.description}
                        </P>
                    </div>
                ))}
            </div>
        </>
    ) : (
        <>
            <div className="bg-white  lg:border flex justify-center  items-center   md:shadow-md min-h-[70vh] md:min-h-full md:overflow-y-scroll  md:max-h-[20rem] rounded-t-2.5 md:rounded-3xl w-full p-3 md:p-1 mt-4 md:mt-0 md:mb-5">
                <P className="text-gray-220 text-center">
                    After Proposal is accepted, The Project breakdown will be
                    shown here.
                </P>
            </div>
        </>
    );
};

export default Activation;
